import React from 'react';


const WalletIcon = () => {
  return <div>
    {/* <Wallet2 size="24" color="#40a9ff" variant="Bold"/> */}
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="vuesax_bold_wallet-2" data-name="vuesax/bold/wallet-2" transform="translate(-684 -316)">
        <g id="wallet-2">
          <path id="Vector" d="M0,0H24V24H0Z" transform="translate(708 340) rotate(180)" fill="none" opacity="0"/>
          <path id="Vector-2" data-name="Vector" d="M5.129,1.02V3.08a1.027,1.027,0,0,1-1,1.02H2.169A2.132,2.132,0,0,1,.009,2.23,2.008,2.008,0,0,1,.609.6,1.993,1.993,0,0,1,2.049,0h2.08A1.027,1.027,0,0,1,5.129,1.02Z" transform="translate(700.871 325.95)" fill="#fff"/>
          <path id="Vector-3" data-name="Vector" d="M18.47,12.05H17.04A3.645,3.645,0,0,1,13.38,8.8a3.518,3.518,0,0,1,1.05-2.82,3.442,3.442,0,0,1,2.49-1.03h1.55a.491.491,0,0,0,.5-.53A4.6,4.6,0,0,0,14.75.05,4.573,4.573,0,0,0,14,0H5a5.322,5.322,0,0,0-.81.06A4.654,4.654,0,0,0,0,5v7a5,5,0,0,0,5,5h9a4.682,4.682,0,0,0,4.97-4.42A.491.491,0,0,0,18.47,12.05ZM11,6.25H5a.75.75,0,0,1,0-1.5h6a.75.75,0,0,1,0,1.5Z" transform="translate(686 319.5)" fill="#fff"/>
        </g>
      </g>
    </svg>

  </div>;
};

export default WalletIcon;
